exports = module.exports = require("../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._12OR13Wyw32TWqVGoUFpTt{width:100%;height:100%}", ""]);
// Exports
exports.locals = {
	"uiLessContainer": "_12OR13Wyw32TWqVGoUFpTt"
};